export default __webpack_public_path__ + "static/media/Stamp7.40be47bb.svg";